import { render } from "./modal-error.vue?vue&type=template&id=50138f4d"
import script from "./modal-error.vue?vue&type=script&lang=js"
export * from "./modal-error.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__